module.exports = __webpack_public_path__ + "img/cabinet-2-min.6444a042.png";